import { render, staticRenderFns } from "./Kelurahan.vue?vue&type=template&id=0ae93bc0&"
import script from "./Kelurahan.vue?vue&type=script&lang=js&"
export * from "./Kelurahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports